import { Base } from "../../framework/base";
import { EditItem, IEditItem } from "../common/editItem";
import { ApprovalType, RiskAssesmentFrequency, RiskType } from "../enums";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export const getNextAssessmentDate = (assesmentFrequency: RiskAssesmentFrequency, date: number): number => {
    const dateObj = new Date(date);
    if (assesmentFrequency === RiskAssesmentFrequency.Continuous) return dateObj.addDays(7).getTime();
    if (assesmentFrequency === RiskAssesmentFrequency.Monthly) return dateObj.addMonths(1).getTime();
    if (assesmentFrequency === RiskAssesmentFrequency.Quarterly) return dateObj.addMonths(3).getTime();
    if (assesmentFrequency === RiskAssesmentFrequency.HalfYearly) return dateObj.addMonths(6).getTime();
    return dateObj.addYears(1).getTime();
};

export interface IRiskAssessmentEditItem extends IEditItem {
    riskId: string;
    riskType: RiskType;
    date: number;
    assessor: string;
    nextAssessmentDate: number;
    likelihood: number;
    impact: number;
    riskLevel: number;
    controlEffiency: number;
    comment: string;
    treatments: string;
    treatmentTargetDate: number;
    treatmentEfficiency: number;
    residualRiskLevel: number;
    approval?: ApprovalType;
    approvalDate?: number;
    approvalAuthority: string;
    approvalJustification: string;
    isRead: boolean;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    lockedUser: IModifyUser;
    personsInCharge: IModifyUser[];

    isLockedToOtherUser(userCode: string): boolean;
}

export class RiskAssessmentEditItem extends EditItem implements IRiskAssessmentEditItem {
    riskId: string;
    riskType: RiskType;
    date: number;
    assessor: string;
    nextAssessmentDate: number;
    likelihood: number;
    impact: number;
    riskLevel: number;
    controlEffiency: number;
    comment: string;
    treatments: string;
    treatmentTargetDate: number;
    treatmentEfficiency: number;
    residualRiskLevel: number;
    approval?: ApprovalType;
    approvalDate?: number;
    approvalAuthority: string;
    approvalJustification: string;
    isRead: boolean;
    createUser: ModifyUser;
    modifyUser: ModifyUser;
    lockedUser: ModifyUser;
    personsInCharge: ModifyUser[];

    constructor();
    constructor(obj: IRiskAssessmentEditItem);
    constructor(obj?: any) {
        super(obj);
        this.riskId = obj && obj.riskId || "";
        this.riskType = obj && obj.riskType || RiskType.Risk;
        this.date = obj && obj.date || 0;
        this.assessor = obj && obj.assessor || "";
        this.nextAssessmentDate = obj && obj.nextAssessmentDate || 0;
        this.likelihood = obj && obj.likelihood || 0;
        this.impact = obj && obj.impact || 0;
        this.riskLevel = obj && obj.riskLevel || 0;
        this.controlEffiency = obj && obj.controlEffiency || 0;
        this.comment = obj && obj.comment || "";
        this.treatments = obj && obj.treatments || "";
        this.treatmentTargetDate = obj && obj.treatmentTargetDate || null;
        this.treatmentEfficiency = obj && obj.treatmentEfficiency || 0;
        this.residualRiskLevel = obj && obj.residualRiskLevel || 0;
        this.approval = obj && obj.approval || null;
        this.approvalDate = obj && obj.approvalDate || null;
        this.approvalAuthority = obj && obj.approvalAuthority || "";
        this.approvalJustification = obj && obj.approvalJustification || "";
        this.isRead = obj && obj.isRead || false;
        this.createUser = new ModifyUser(obj?.createUser);
        this.modifyUser = new ModifyUser(obj?.modifyUser);
        this.lockedUser = obj?.lockedUser ? new ModifyUser(obj.lockedUser) : null;
        this.personsInCharge = Base.getTypedArray(obj.personsInCharge, ModifyUser);
    }

    isLockedToOtherUser(userCode: string): boolean {
        return this.lockedUser?.code && !userCode.equalIgnoreCase(this.lockedUser.code);
    }
}